export enum EUserRole {
  ADMIN = "ADMIN",
  SUPPORT = "SUPPORT",
  OWNER = "OWNER",
  VISITOR = "VISITOR",
}